module.exports = __webpack_public_path__ + "media/video-001.a9df686f.mp4";